import React, { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { getSmileyComponent } from 'screens/analytics/1on1/HoverComponents';
import { StyledTypography } from 'styles/common';

import { oneOnOneMoods } from 'constants/ProjectConstants';
import { StarIcon } from 'constants/icons';

import { DateRange, ExpandedView } from './CohortSidePanel';
import { useCohortCreationContext } from './CohortSidePanelContext';
import { DropdownContainer, RangeSelector, SelectListComp } from './CommonComponents';

const MODULE_NAME = '1:1';

const OneOnOneMood = ({ sectionId, isAllEmployeesSelected, accessibleRole, moduleName }) => {
  const getPreLabelComp = (rating) => () => getSmileyComponent(rating, 'tinierFixed');

  return (
    <>
      <StyledTypography variant="body2" weight={600}>
        Team Member Mood
      </StyledTypography>
      <SelectListComp
        options={oneOnOneMoods}
        sectionId={sectionId}
        preLabelComp={getPreLabelComp}
        isMultiSelect
        dataKey="reporteeMood"
        isAllEmployeesSelected={isAllEmployeesSelected}
        accessibleRole={accessibleRole}
        moduleName={MODULE_NAME}
      />
    </>
  );
};

/**
 * @deprecated 25-06-2025
 */
function CohortCreationOneOnOne({
  content,
  sectionLabel,
  sectionId,
  onHeaderClick,
  accessibleRole,
  isAllEmployeesSelected,
}) {
  const dispatch = useDispatch();
  const { updateBaseCohort } = useCohortCreationContext();

  const latestValue = useRef(isAllEmployeesSelected);

  useEffect(() => {
    latestValue.current = isAllEmployeesSelected;
  }, [isAllEmployeesSelected]);
  return (
    <>
      <ExpandedView
        content={content}
        sectionLabel={sectionLabel}
        sectionId={sectionId}
        headerComponent={() => (
          <DateRange
            sectionId={sectionId}
            onHeaderClick={onHeaderClick}
            goalTextLabel="Timeline"
            isAllEmployeesSelected={isAllEmployeesSelected}
            accessibleRole={accessibleRole}
            moduleName={MODULE_NAME}
          />
        )}
      />
      <DropdownContainer topGutter={3}>
        <RangeSelector
          sectionId={sectionId}
          dataKey="data"
          headingText="Completion Percentage (Range)"
          isAllEmployeesSelected={isAllEmployeesSelected}
          accessibleRole={accessibleRole}
          moduleName={MODULE_NAME}
        />
      </DropdownContainer>
      <DropdownContainer topGutter={3}>
        <OneOnOneMood
          sectionId={sectionId}
          isAllEmployeesSelected={isAllEmployeesSelected}
          accessibleRole={accessibleRole}
          moduleName={MODULE_NAME}
        />
      </DropdownContainer>

      <DropdownContainer topGutter={3}>
        <RangeSelector
          sectionId={sectionId}
          minValue={0}
          maxValue={5}
          inputAdornmentComp={() => <StarIcon size="tinierFixed" color="mustard" />}
          dataKey="reporteeRating"
          headingText="Team Member Score (Range)"
          isAllEmployeesSelected={isAllEmployeesSelected}
          accessibleRole={accessibleRole}
          moduleName={MODULE_NAME}
        />
      </DropdownContainer>
    </>
  );
}

export default CohortCreationOneOnOne;
